module.exports = __webpack_public_path__ + "assets/new_zh.24073bdcd1241e4b0f98083bd914c411.png";